import { IGetAllTermoUseCase } from "../../../presentation/useCases/read/get_all_termo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { Termo } from "../../models/termo";

/**
 * GetAllTermoUseCase
 */

export class GetAllTermoUseCase extends BasePaginatedUseCase<Termo> implements IGetAllTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    codigo?: string,
    descricao?: string,
    nome?: string,
    status?: number,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const result = await this.repository.getAllTermos(
      codigo ?? '',
      descricao ?? '',
      nome ?? '',
      status ?? 2,

      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
